<template>
	<div>
		<h4 class="mb-3">{{ $t('choose-a-form-and-status') }}</h4>

		<div class="form-group">
			<label for="upload-form">{{ $t('form') }}</label>
			<b-form-select id="upload-form" v-model="localFormId" :options="formOptions"></b-form-select>
		</div>

		<div class="form-group">
			<label>{{ $t('mark-imported-responses-as') }}</label>
			<b-form-group>
				<b-form-radio v-model="localStatus" value="draft">{{ $t('draft') }}</b-form-radio>
				<b-form-radio v-model="localStatus" value="completed">{{ $t('completed') }}</b-form-radio>
				<b-form-radio v-model="localStatus" value="signedoff">{{ $t('signed-off') }}</b-form-radio>
			</b-form-group>
		</div>

		<div class="form-group" v-if="status === 'signedoff'">
			<label for="upload-signoff-user">{{ $t('signed-off-by') }}</label>
			<b-form-select id="upload-signoff-user" v-model="localSignoffUserId" :options="signoffUserOptions"></b-form-select>
		</div>

		<b-button variant="primary" :disabled="!formId || (status === 'signedoff' && !signoffUserId)" @click="$emit('next')">
			{{ $t('next') }} →
		</b-button>
	</div>
</template>

<script>
export default {
	props: {
		forms:         { type: Array,  default: () => [] },
		formId:        { type: [Number, String], default: null },
		status:        { type: String, default: 'draft' },
		signoffUsers:  { type: Array,  default: () => [] },
		signoffUserId: { type: [Number, String], default: null },
	},
	computed: {
		formOptions() {
			return [
				{ value: null, text: this.$t('select-caps') },
				...this.forms.map(f => ({ value: f.id, text: f.title })),
			];
		},
		signoffUserOptions() {
			return [
				{ value: null, text: this.$t('select-caps') },
				...this.signoffUsers.map(u => ({ value: u.id, text: u.displayName })),
			];
		},
		localFormId: {
			get()  { return this.formId; },
			set(v) { this.$emit('update:formId', v); },
		},
		localStatus: {
			get()  { return this.status; },
			set(v) { this.$emit('update:status', v); },
		},
		localSignoffUserId: {
			get()  { return this.signoffUserId; },
			set(v) { this.$emit('update:signoffUserId', v); },
		},
	},
};
</script>
